import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'
import { AchievementBadge } from '../content'

export const Achievement = pgTable(
  'achievement',
  {
    id: uuid().defaultRandom().primaryKey(),
    achievementBadgeId: uuid()
      .references(() => AchievementBadge.id, { onDelete: 'cascade' })
      .notNull(),
    userId: text()
      .references(() => user.id, { onDelete: 'cascade' })
      .notNull(),
    claimedAt: timestamp({ mode: 'date', withTimezone: true }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),

    // Legacy
    legacyUserBadgeId: integer(),
  },
  (t) => [
    index('idx_achievement_user').on(t.userId),
    unique('idx_achievement_badge_user').on(t.achievementBadgeId, t.userId),
  ],
)

export const achievementRelations = relations(Achievement, ({ one }) => ({
  achievementBadge: one(AchievementBadge, {
    fields: [Achievement.achievementBadgeId],
    references: [AchievementBadge.id],
  }),

  user: one(user, {
    fields: [Achievement.userId],
    references: [user.id],
  }),
}))

export const InsertAchievementSchema = createInsertSchema(Achievement).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateAchievementSchema = createUpdateSchema(Achievement).partial().omit({
  id: true,
  userId: true,
  achievementBadgeId: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectAchievementSchema = createSelectSchema(Achievement)

export type InsertAchievement = typeof Achievement.$inferInsert
export type UpdateAchievement = z.infer<typeof UpdateAchievementSchema>
export type SelectAchievement = typeof Achievement.$inferSelect
